import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';

const CheckboxInput = ({ name, label, onChange, value, checked, disabled }) => {
  const uniqueIdentifier = `${value}-${name}`;

  return (
    <div className="checkbox-input">
      <input
        type="checkbox"
        id={uniqueIdentifier}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <label htmlFor={uniqueIdentifier}>{renderHTML(label)}</label>
    </div>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/CheckboxInput.js